// pre defined modules
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// user defined modules
import { AppRoutingModule } from './app-routing.module';
// user defined components
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';




@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    DragDropModule
  ],
  providers: [

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
